module.exports = __webpack_public_path__ + "static/Verne4-e7feb8e78695d6775eca1bf1316ecac6.png";